module.exports = __webpack_public_path__ + "c2c9e1ce7af119f3261a70d915d5ca12.mp3";